'use client'

import dynamic from 'next/dynamic'

import React from 'react';



import { useTranslation } from 'react-i18next';
const NavDropMenu = dynamic(() => import('../navDrop/NavDropMenu'), { ssr: false })



export default  function MainNavList({navSections, navAboutLinks}) {

    const {t} = useTranslation();

    return (
      <div className=" flex flex-col mt-4 mb-6 p-0 lg:mt-0 lg:mb-0 lg:flex-row lg:p-0 gap-x-1">
  
  
        <NavDropMenu page={'about'} title={t('about')} dropMenu={'About us'} dropContent={navAboutLinks} />
        <NavDropMenu page={'products'} title={t('products')} dropMenu={'Products'} dropContent={navSections} />
  
  
        <a
          href="/articles"
          className="text-sm text-blue-gray-900 "
        >
          <div className=" flex items-center gap-2 py-2 px-2 rounded-md hover:bg-gray-100 hover:text-chimib-600">
  
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-[18px] h-[18px]">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v3H6v-3z" />
            </svg>
  
            <p className='text-sm text-blue-gray'>{t('blog')}</p>
          </div>
        </a>
  
        <a
          href="/gallery"
          className="text-sm text-blue-gray-900"
        >
          <div className=" flex items-center gap-2 py-2 px-2 rounded-md hover:bg-gray-100 hover:text-chimib-600">
  
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-[18px] h-[18px]">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
            </svg>
  
            <p className='text-sm'>{t('media')}</p>
            
  
          </div>
        </a>
  

        <a
          href="/contact"
          className="text-sm text-blue-gray-900"
        >
          <div className=" flex items-center gap-2 py-2 px-2 rounded-md hover:bg-gray-100 hover:text-chimib-600">
  
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-[18px] h-[18px]">
            <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
          </svg>

            <p className='text-sm'>{t('contact')}</p>
            
  
          </div>
        </a>
            
        {/* <NavListMenu page={'contact'} title={t('contact')} dropMenu={'Contact'} dropContent={navListContactItems} />
   */}
  
      </div>
    );
  }
  